module.exports = __webpack_public_path__ + "img/avatar.4739ce62.svg";